import { intakeConstants } from '../_constants/intake.constants';
import { intakeService } from '../_services/intake.service';
import { alertActions } from './alert.actions'

export function searchIntake(params = {}) {
  return dispatch => {
    dispatch(request());

    intakeService.search(params)
      .then((collection) => {
        dispatch(success(collection));
      })
      .catch(() => {
        dispatch(alertActions.error("Could not retrieve intake."));
      });
  }

  function request() { return { type: intakeConstants.INTAKE_SEARCH_REQUEST } }
  function success(collection) { return { type: intakeConstants.INTAKE_SEARCH_SUCCESS, collection } }
}
